/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */
/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */
// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript';
// @ts-ignore
import request from "../request";
const mockUrl_0_0_0_0 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_0 = "";
const prodUrl_0_0_0_0 = "";
const dataKey_0_0_0_0 = "data";
/**
 * 接口 切换支付方式 的 **请求配置**
 *
 * @分类 采购API/代采单
 * @请求头 `POST /erp/WcgOrder/switchingPaymentMethods`
 */
const postSwitchingPaymentMethodsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgOrder/switchingPaymentMethods",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSwitchingPaymentMethods",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 切换支付方式 的 **请求函数**
 *
 * @分类 采购API/代采单
 * @请求头 `POST /erp/WcgOrder/switchingPaymentMethods`
 */
export const postSwitchingPaymentMethods = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postSwitchingPaymentMethodsRequestConfig, requestData),
    ...args
  );
};
postSwitchingPaymentMethods.requestConfig =
  postSwitchingPaymentMethodsRequestConfig;
/**
 * 接口 获取商家可用抵扣商品数据 的 **请求配置**
 *
 * @分类 采购API/代采单
 * @请求头 `POST /erp/WcgOrder/getDedDataByPrice`
 */
const postGetDedDataByPriceRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgOrder/getDedDataByPrice",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetDedDataByPrice",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取商家可用抵扣商品数据 的 **请求函数**
 *
 * @分类 采购API/代采单
 * @请求头 `POST /erp/WcgOrder/getDedDataByPrice`
 */
export const postGetDedDataByPrice = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetDedDataByPriceRequestConfig, requestData),
    ...args
  );
};
postGetDedDataByPrice.requestConfig = postGetDedDataByPriceRequestConfig;
/**
 * 接口 代采订单列表-筛选项 的 **请求配置**
 *
 * @分类 采购API/代采单
 * @请求头 `POST /erp/WcgOrder/optionsForWcgOrderList`
 */
const postOptionsForWcgOrderListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: "/erp/WcgOrder/optionsForWcgOrderList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postOptionsForWcgOrderList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 代采订单列表-筛选项 的 **请求函数**
 *
 * @分类 采购API/代采单
 * @请求头 `POST /erp/WcgOrder/optionsForWcgOrderList`
 */
export const postOptionsForWcgOrderList = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postOptionsForWcgOrderListRequestConfig, requestData),
    ...args
  );
};
postOptionsForWcgOrderList.requestConfig =
  postOptionsForWcgOrderListRequestConfig;
const mockUrl_0_0_0_1 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_1 = "";
const prodUrl_0_0_0_1 = "";
const dataKey_0_0_0_1 = "data";
/**
 * 接口 代采报表详情-点击坏账 的 **请求配置**
 *
 * @分类 采购API/代采报表
 * @请求头 `POST /erp/WcgOrder/getBrokenDebtOfWcg`
 */
const postGetBrokenDebtOfWcgRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/WcgOrder/getBrokenDebtOfWcg",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetBrokenDebtOfWcg",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 代采报表详情-点击坏账 的 **请求函数**
 *
 * @分类 采购API/代采报表
 * @请求头 `POST /erp/WcgOrder/getBrokenDebtOfWcg`
 */
export const postGetBrokenDebtOfWcg = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetBrokenDebtOfWcgRequestConfig, requestData),
    ...args
  );
};
postGetBrokenDebtOfWcg.requestConfig = postGetBrokenDebtOfWcgRequestConfig;
/**
 * 接口 获取采购报表及汇总筛选项 的 **请求配置**
 *
 * @分类 采购API/代采报表
 * @请求头 `GET /erp/WcgOrder/optionsForGetDataOfWcg`
 */
const getOptionsForGetDataOfWcgRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_1,
  devUrl: devUrl_0_0_0_1,
  prodUrl: prodUrl_0_0_0_1,
  path: "/erp/WcgOrder/optionsForGetDataOfWcg",
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_1,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "getOptionsForGetDataOfWcg",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取采购报表及汇总筛选项 的 **请求函数**
 *
 * @分类 采购API/代采报表
 * @请求头 `GET /erp/WcgOrder/optionsForGetDataOfWcg`
 */
export const getOptionsForGetDataOfWcg = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(getOptionsForGetDataOfWcgRequestConfig, requestData),
    ...args
  );
};
getOptionsForGetDataOfWcg.requestConfig =
  getOptionsForGetDataOfWcgRequestConfig;
const mockUrl_0_0_0_2 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_2 = "";
const prodUrl_0_0_0_2 = "";
const dataKey_0_0_0_2 = "data";
/**
 * 接口 根据采购单\/账单获取活动商品 的 **请求配置**
 *
 * @分类 旧接口文档/采购商品
 * @请求头 `POST /erp/WcgOrder/listActivityGoodsByOrder`
 */
const postListActivityGoodsByOrderRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/WcgOrder/listActivityGoodsByOrder",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postListActivityGoodsByOrder",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 根据采购单\/账单获取活动商品 的 **请求函数**
 *
 * @分类 旧接口文档/采购商品
 * @请求头 `POST /erp/WcgOrder/listActivityGoodsByOrder`
 */
export const postListActivityGoodsByOrder = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postListActivityGoodsByOrderRequestConfig, requestData),
    ...args
  );
};
postListActivityGoodsByOrder.requestConfig =
  postListActivityGoodsByOrderRequestConfig;
/**
 * 接口 获取采购订单详情数据 的 **请求配置**
 *
 * @分类 旧接口文档/采购商品
 * @请求头 `POST /erp/WcgOrder/getOrderInfo`
 */
const postGetOrderInfoRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_2,
  devUrl: devUrl_0_0_0_2,
  prodUrl: prodUrl_0_0_0_2,
  path: "/erp/WcgOrder/getOrderInfo",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_2,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetOrderInfo",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取采购订单详情数据 的 **请求函数**
 *
 * @分类 旧接口文档/采购商品
 * @请求头 `POST /erp/WcgOrder/getOrderInfo`
 */
export const postGetOrderInfo = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetOrderInfoRequestConfig, requestData), ...args);
};
postGetOrderInfo.requestConfig = postGetOrderInfoRequestConfig;
const mockUrl_0_0_0_3 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_3 = "";
const prodUrl_0_0_0_3 = "";
const dataKey_0_0_0_3 = "data";
/**
 * 接口 获取待开单的商品列表 的 **请求配置**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/getBillingInfoOnPc`
 */
const postGetBillingInfoOnPcRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/WcgOrder/getBillingInfoOnPc",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetBillingInfoOnPc",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取待开单的商品列表 的 **请求函数**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/getBillingInfoOnPc`
 */
export const postGetBillingInfoOnPc = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetBillingInfoOnPcRequestConfig, requestData),
    ...args
  );
};
postGetBillingInfoOnPc.requestConfig = postGetBillingInfoOnPcRequestConfig;
/**
 * 接口 提交核单 的 **请求配置**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/submitBilling`
 */
const postSubmitBillingRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/WcgOrder/submitBilling",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSubmitBilling",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 提交核单 的 **请求函数**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/submitBilling`
 */
export const postSubmitBilling = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postSubmitBillingRequestConfig, requestData), ...args);
};
postSubmitBilling.requestConfig = postSubmitBillingRequestConfig;
/**
 * 接口 修改核单数量 的 **请求配置**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/setBillingNum`
 */
const postSetBillingNumRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/WcgOrder/setBillingNum",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postSetBillingNum",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 修改核单数量 的 **请求函数**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/setBillingNum`
 */
export const postSetBillingNum = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postSetBillingNumRequestConfig, requestData), ...args);
};
postSetBillingNum.requestConfig = postSetBillingNumRequestConfig;
/**
 * 接口 开单时获取活动费用商品 的 **请求配置**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/listActivityGoods`
 */
const postListActivityGoodsRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/WcgOrder/listActivityGoods",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postListActivityGoods",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 开单时获取活动费用商品 的 **请求函数**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/listActivityGoods`
 */
export const postListActivityGoods = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postListActivityGoodsRequestConfig, requestData),
    ...args
  );
};
postListActivityGoods.requestConfig = postListActivityGoodsRequestConfig;
/**
 * 接口 开单详情H5 的 **请求配置**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/getBillingDetailOnH5`
 */
const postGetBillingDetailOnH5RequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/WcgOrder/getBillingDetailOnH5",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.raw,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetBillingDetailOnH5",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 开单详情H5 的 **请求函数**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/getBillingDetailOnH5`
 */
export const postGetBillingDetailOnH5 = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postGetBillingDetailOnH5RequestConfig, requestData),
    ...args
  );
};
postGetBillingDetailOnH5.requestConfig = postGetBillingDetailOnH5RequestConfig;
/**
 * 接口 获取待开单的商品列表 的 **请求配置**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/getBillingList`
 */
const postGetBillingListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/WcgOrder/getBillingList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetBillingList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取待开单的商品列表 的 **请求函数**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/getBillingList`
 */
export const postGetBillingList = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetBillingListRequestConfig, requestData),
    ...args
  );
};
postGetBillingList.requestConfig = postGetBillingListRequestConfig;
/**
 * 接口 获取某款商品的价格费用 的 **请求配置**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/getGoodsFee`
 */
const postGetGoodsFeeRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/WcgOrder/getGoodsFee",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetGoodsFee",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取某款商品的价格费用 的 **请求函数**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/getGoodsFee`
 */
export const postGetGoodsFee = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetGoodsFeeRequestConfig, requestData), ...args);
};
postGetGoodsFee.requestConfig = postGetGoodsFeeRequestConfig;
/**
 * 接口 获取采购单配置开关 的 **请求配置**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/getWcgOrderConfig`
 */
const postGetWcgOrderConfigRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/WcgOrder/getWcgOrderConfig",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: true,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetWcgOrderConfig",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 获取采购单配置开关 的 **请求函数**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/getWcgOrderConfig`
 */
export const postGetWcgOrderConfig = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetWcgOrderConfigRequestConfig, requestData),
    ...args
  );
};
postGetWcgOrderConfig.requestConfig = postGetWcgOrderConfigRequestConfig;
/**
 * 接口 采购单商品列表 的 **请求配置**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/getGoodsList`
 */
const postGetGoodsListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/WcgOrder/getGoodsList",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetGoodsList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 采购单商品列表 的 **请求函数**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/getGoodsList`
 */
export const postGetGoodsList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetGoodsListRequestConfig, requestData), ...args);
};
postGetGoodsList.requestConfig = postGetGoodsListRequestConfig;
/**
 * 接口 采购报表 的 **请求配置**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/GetDataOfWcg`
 */
const postGetDataOfWcgRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/WcgOrder/GetDataOfWcg",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetDataOfWcg",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 采购报表 的 **请求函数**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/GetDataOfWcg`
 */
export const postGetDataOfWcg = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postGetDataOfWcgRequestConfig, requestData), ...args);
};
postGetDataOfWcg.requestConfig = postGetDataOfWcgRequestConfig;
/**
 * 接口 采购订单列表 的 **请求配置**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/list`
 */
const postListRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_3,
  devUrl: devUrl_0_0_0_3,
  prodUrl: prodUrl_0_0_0_3,
  path: "/erp/WcgOrder/list",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_3,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postList",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 采购订单列表 的 **请求函数**
 *
 * @分类 旧接口文档/采购管理
 * @请求头 `POST /erp/WcgOrder/list`
 */
export const postList = /*#__PURE__*/ (requestData, ...args) => {
  return request(prepare(postListRequestConfig, requestData), ...args);
};
postList.requestConfig = postListRequestConfig;
const mockUrl_0_0_0_4 = "http://127.0.0.1:50505/mock/0";
const devUrl_0_0_0_4 = "";
const prodUrl_0_0_0_4 = "";
const dataKey_0_0_0_4 = "data";
/**
 * 接口 判断是否有可抵扣的让利账单 的 **请求配置**
 *
 * @分类 旧接口文档/爆版4.28(erp)
 * @请求头 `POST /erp/WcgOrder/getSupplyRpDed`
 */
const postGetSupplyRpDedRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/WcgOrder/getSupplyRpDed",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postGetSupplyRpDed",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 判断是否有可抵扣的让利账单 的 **请求函数**
 *
 * @分类 旧接口文档/爆版4.28(erp)
 * @请求头 `POST /erp/WcgOrder/getSupplyRpDed`
 */
export const postGetSupplyRpDed = /*#__PURE__*/ (requestData, ...args) => {
  return request(
    prepare(postGetSupplyRpDedRequestConfig, requestData),
    ...args
  );
};
postGetSupplyRpDed.requestConfig = postGetSupplyRpDedRequestConfig;
/**
 * 接口 根据金钱去获取需要抵扣让利账单 的 **请求配置**
 *
 * @分类 旧接口文档/爆版4.28(erp)
 * @请求头 `POST /erp/WcgOrder/listReturnProfitBillByAmount`
 */
const postListReturnProfitBillByAmountRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/WcgOrder/listReturnProfitBillByAmount",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postListReturnProfitBillByAmount",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 根据金钱去获取需要抵扣让利账单 的 **请求函数**
 *
 * @分类 旧接口文档/爆版4.28(erp)
 * @请求头 `POST /erp/WcgOrder/listReturnProfitBillByAmount`
 */
export const postListReturnProfitBillByAmount = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postListReturnProfitBillByAmountRequestConfig, requestData),
    ...args
  );
};
postListReturnProfitBillByAmount.requestConfig =
  postListReturnProfitBillByAmountRequestConfig;
/**
 * 接口 采购订单抵扣明细 的 **请求配置**
 *
 * @分类 旧接口文档/爆版4.28(erp)
 * @请求头 `POST /erp/WcgOrder/listWoReturnProfitBillDetail`
 */
const postListWoReturnProfitBillDetailRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_4,
  devUrl: devUrl_0_0_0_4,
  prodUrl: prodUrl_0_0_0_4,
  path: "/erp/WcgOrder/listWoReturnProfitBillDetail",
  method: Method.POST,
  requestHeaders: {},
  requestBodyType: RequestBodyType.form,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_4,
  paramNames: [],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: "postListWoReturnProfitBillDetail",
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};
/**
 * 接口 采购订单抵扣明细 的 **请求函数**
 *
 * @分类 旧接口文档/爆版4.28(erp)
 * @请求头 `POST /erp/WcgOrder/listWoReturnProfitBillDetail`
 */
export const postListWoReturnProfitBillDetail = /*#__PURE__*/ (
  requestData,
  ...args
) => {
  return request(
    prepare(postListWoReturnProfitBillDetailRequestConfig, requestData),
    ...args
  );
};
postListWoReturnProfitBillDetail.requestConfig =
  postListWoReturnProfitBillDetailRequestConfig;
/* prettier-ignore-end */



// WEBPACK FOOTER //
// ./src/openapi/erp/wcgOrder.js